import { WaterPumpOffIcon } from './WaterPumpOffIcon';

/**
 * author: Nick
 * id A66B4E6E-70F9-4136-BE33-D02C002F7B30
 * name water-pump-off
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water-pump-off.svg
 * tags
 * - Agriculture 
 * - Home Automation 
 */
export const KitchenTapOffIcon = WaterPumpOffIcon;
export default KitchenTapOffIcon